export default __webpack_public_path__ + "mfa-scan-qr-logo.e040cd855f6e6de3312aa8d59a4a9255.svg";